import E6Box from "./src/box.vue";

E6Box.install = function (Vue) {
  Vue.component(E6Box.name, E6Box);
};

export default E6Box;
